export default {
  1: {
    description: 'Sunny',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/1.svg',
  },
  2: {
    description: 'Mostly Sunny',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/2.svg',
  },
  3: {
    description: 'Partly Sunny',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/3.svg',
  },
  4: {
    description: 'Intermittent Clouds',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/4.svg',
  },
  5: {
    description: 'Hazy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/5.svg',
  },
  6: {
    description: 'Mostly Cloudy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/6.svg',
  },
  7: {
    description: 'Cloudy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/7.svg',
  },
  8: {
    description: 'Cloudy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/8.svg',
  },
  9: {
    description: 'Unknown',
    iconUrl: '',
  },
  10: {
    description: 'Unknown',
    iconUrl: '',
  },
  11: {
    description: 'Foggy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/11.svg',
  },
  12: {
    description: 'Chance of Rain Showers',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/12.svg',
  },
  13: {
    description: 'Mostly Cloudy w/ Showers',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/13.svg',
  },
  14: {
    description: 'Partly Sunny w/ Showers',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/14.svg',
  },
  15: {
    description: 'Thunderstorms',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/15.svg',
  },
  16: {
    description: 'Mostly Cloudy w/ Ttorms',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/16.svg',
  },
  17: {
    description: 'Partly Sunny w/ Ttorms',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/17.svg',
  },
  18: {
    description: 'Rain',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/18.svg',
  },
  19: {
    description: 'Flurries',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/19.svg',
  },
  20: {
    description: 'Mostly Cloudy w/ Flurries',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/20.svg',
  },
  21: {
    description: 'Partly Sunny w/ Flurries',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/21.svg',
  },
  22: {
    description: 'Snow',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/22.svg',
  },
  23: {
    description: 'Mostly Cloudy w/ Snow',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/23.svg',
  },
  24: {
    description: 'Ice',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/24.svg',
  },
  25: {
    description: 'Sleet',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/25.svg',
  },
  26: {
    description: 'Freezing Rain',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/26.svg',
  },
  27: {
    description: 'Unknown',
    iconUrl: '',
  },
  28: {
    description: 'Unknown',
    iconUrl: '',
  },
  29: {
    description: 'Rain and Snow',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/29.svg',
  },
  30: {
    description: 'Hot',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/30.svg',
  },
  31: {
    description: 'Cold',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/31.svg',
  },
  32: {
    description: 'Windy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/32.svg',
  },
  33: {
    description: 'Clear',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/33.svg',
  },
  34: {
    description: 'Mostly Clear',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/34.svg',
  },
  35: {
    description: 'Partly Cloudy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/35.svg',
  },
  36: {
    description: 'Intermittent Clouds',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/36.svg',
  },
  37: {
    description: 'Hazy (Night)',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/37.svg',
  },
  38: {
    description: 'Mostly Cloudy',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/38.svg',
  },
  39: {
    description: 'Partly Cloudy w/ Showers',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/39.svg',
  },
  40: {
    description: 'Mostly Cloudy w/ Showers',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/40.svg',
  },
  41: {
    description: 'Partly Cloudy w/ Ttorms',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/40.svg',
  },
  42: {
    description: 'Mostly Cloudy w/ Ttorms',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/40.svg',
  },
  43: {
    description: 'Mostly Cloudy w/ Flurries',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/43.svg',
  },
  44: {
    description: 'Mostly Cloudy w/ Snow',
    iconUrl:
      'https://www.accuweather.com/assets/images/weather-icons/v2a/44.svg',
  },
};
